module.exports = __webpack_public_path__ + "static/img/ai_training_bg.da439fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_training/ai_training_bg.png
// module id = AmgU
// module chunks = 1